import { useEffect, useState, useRef } from "react";

import scratchicon from '../img/scratchicon.svg';
import badgeshine from '../img/badgeshine.png';

const getAssetUrl = (baseurl, url) => {
  if (!url) return "";
  if (/^(https?:)?\/\//.test(url) || url.startsWith("data:") || url.startsWith("blob:")) {
    return url;
  }

  return `${baseurl || ""}${url}`;
};


function ContentMagnifier(props) {
  const { content } = props;
  const [pos, setPos] = useState({ x: -9999, y: -9999 });
  const [visible, setVisible] = useState(false);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef(null);

  const bubbleRadius = Number(content?.radius ?? 80); // px
  const zoom = Number(content?.zoom ?? 2.4);
  const offsetX = Number(content?.offsetX ?? -20);
  const offsetY = Number(content?.offsetY ?? -60);
  const backgroundUrl = getAssetUrl(props.baseurl, content?.backgroundurl || content?.imageurl || content?.url);
  const zoomImageUrl = getAssetUrl(
    props.baseurl,
    content?.innerimageurl || content?.magnifierurl || content?.zoomimageurl || content?.backgroundurl || content?.imageurl || content?.url
  );

  const updateContainerSize = () => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;

    setContainerSize({ width: rect.width, height: rect.height });
  };

  useEffect(() => {
    updateContainerSize();
    window.addEventListener("resize", updateContainerSize);

    return () => window.removeEventListener("resize", updateContainerSize);
  }, []);

  useEffect(() => {
    if (!zoomImageUrl) return;

    const image = new Image();
    image.onload = () => {
      setImageSize({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.src = zoomImageUrl;

    return () => {
      image.onload = null;
    };
  }, [zoomImageUrl]);

  const getCoords = (e) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return pos;

    const pointer = e.touches?.[0] || e.changedTouches?.[0] || e;
    const x = pointer.clientX - rect.left;
    const y = pointer.clientY - rect.top;
    setContainerSize({ width: rect.width, height: rect.height });
    return { x, y };
  };

  const handleStart = (e) => {
    const { x, y } = getCoords(e);
    setPos({ x, y });
    setVisible(true);
    props.showButtons?.(false);
  };

  const handleMove = (e) => {
    if (!visible) return;
    const { x, y } = getCoords(e);
    setPos({ x, y });
  };

  const handleEnd = () => {
    setVisible(false);
    props.showButtons?.(true);
  };

  const cx = pos.x + offsetX;
  const cy = pos.y + offsetY;
  const containerAspect = containerSize.width / containerSize.height;
  const imageAspect = imageSize.width && imageSize.height
    ? imageSize.width / imageSize.height
    : containerAspect || 1;
  const coverWidth = containerAspect > imageAspect
    ? containerSize.width
    : containerSize.height * imageAspect;
  const coverHeight = containerAspect > imageAspect
    ? containerSize.width / imageAspect
    : containerSize.height;
  const imageOffsetX = (containerSize.width - coverWidth) / 2;
  const imageOffsetY = (containerSize.height - coverHeight) / 2;
  const backgroundPositionX = bubbleRadius - ((cx - imageOffsetX) * zoom);
  const backgroundPositionY = bubbleRadius - ((cy - imageOffsetY) * zoom);

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        touchAction: "none",
      }}
      onMouseDown={handleStart}
      onMouseMove={handleMove}
      onMouseUp={handleEnd}
      onMouseLeave={handleEnd}
      onTouchStart={handleStart}
      onTouchMove={handleMove}
      onTouchEnd={handleEnd}
      onTouchCancel={handleEnd}
      className="page-content-inspector page-content-magnifier"
    >

      <div className={`scratchicon ${visible && "scratchiconremoved"}`} ><img src={scratchicon} className='scratchiconimg' alt="" /></div>

      <div
        style={{
          backgroundImage: `url(${backgroundUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          inset: 0,
        }}
      />

      <div
        style={{
          backgroundImage: `url(${zoomImageUrl})`,
          backgroundSize: `${coverWidth * zoom}px ${coverHeight * zoom}px`,
          backgroundPosition: `${backgroundPositionX}px ${backgroundPositionY}px`,
          backgroundRepeat: "no-repeat",
          position: "absolute",
          left: `${cx - bubbleRadius}px`,
          top: `${cy - bubbleRadius}px`,
          width: `${bubbleRadius * 2}px`,
          height: `${bubbleRadius * 2}px`,
          borderRadius: "50%",
          border: "5px solid #fff",
          boxShadow: "0 12px 34px rgba(0,0,0,0.35)",
          boxSizing: "border-box",
          overflow: "hidden",
          pointerEvents: "none",
          opacity: visible ? 1 : 0,
          transform: visible ? "scale(1)" : "scale(0.96)",
          transition: "opacity 0.12s ease, transform 0.12s ease",
          willChange: "left, top, background-position",
        }}
      >
        <img src={badgeshine} className="badgeshine" alt="" />
      </div>
    </div>
  );
}

export default ContentMagnifier;
